import React, { FormEvent, useState } from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { eventOffers } from '../data/events';
import { inputClass, labelClass } from '../utils/styles';
export function EventRequestForm() {
  const {
    t,
    l
  } = useLanguage();
  const e = t.events;
  const [form, setForm] = useState({
    name: '',
    email: '',
    date: '',
    type: eventOffers[0].id,
    message: ''
  });
  const [error, setError] = useState(false);
  const [sent, setSent] = useState(false);
  const set = (key: keyof typeof form) => (ev: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => setForm({
    ...form,
    [key]: ev.target.value
  });
  function handleSubmit(ev: FormEvent) {
    ev.preventDefault();
    if (!form.name.trim() || !form.email.trim() || !form.date) {
      setError(true);
      return;
    }
    setError(false);
    setSent(true);
  }
  if (sent) {
    return <div className="flex items-start gap-3 rounded-xl bg-cream p-6" role="status" data-id="element-70" data-mp="362m71ep7eb4w">
        <CheckCircle2Icon className="h-6 w-6 shrink-0 text-moss" aria-hidden="true" data-id="element-71" data-mp="2oz5bnjflsufg" />
        <p className="text-lg text-bark" data-id="element-72" data-mp="2k1djqpeyl8b9">{e.sent}</p>
      </div>;
  }
  return <form noValidate onSubmit={handleSubmit} className="space-y-4 rounded-xl bg-cream p-6 sm:p-8" aria-labelledby="event-form-title" data-id="element-73" data-mp="2yy4lv6g0oy4k">
      <h3 id="event-form-title" className="font-serif text-2xl font-bold text-bark" data-id="element-74" data-mp="2ty02n8nq5pan">{e.request}</h3>
      <div className="grid gap-4 sm:grid-cols-2" data-id="element-75" data-mp="268e6ku2nfq6v">
        <div data-id="element-76" data-mp="21c6z2wulu6mt">
          <label htmlFor="ev-name" className={labelClass} data-id="element-77" data-mp="21cqf280p2ky7">{e.name}</label>
          <input id="ev-name" value={form.name} onChange={set('name')} className={inputClass} data-id="element-78" data-mp="2g0toxshuygsa" />
        </div>
        <div data-id="element-79" data-mp="2b9biwq0z9q0g">
          <label htmlFor="ev-email" className={labelClass} data-id="element-80" data-mp="2b8tgtcrmwhkm">{e.email}</label>
          <input id="ev-email" type="email" value={form.email} onChange={set('email')} className={inputClass} data-id="element-81" data-mp="1nj7ierj366do" />
        </div>
        <div data-id="element-82" data-mp="1ik4p24cgxolj">
          <label htmlFor="ev-type" className={labelClass} data-id="element-83" data-mp="1iknvoowo4qk9">{e.type}</label>
          <select id="ev-type" value={form.type} onChange={set('type')} className={inputClass} data-id="element-84" data-mp="2880ezfdh4zu5">
            {eventOffers.map(offer => <option key={offer.id} value={offer.id} data-id="element-85" data-mp="2c8kbcgq83zf8">{l(offer.title)}</option>)}
          </select>
        </div>
        <div data-id="element-86" data-mp="2m06qup9lgkns">
          <label htmlFor="ev-date" className={labelClass} data-id="element-87" data-mp="2m0pz1e9fzuom">{e.date}</label>
          <input id="ev-date" type="date" min="2027-04-01" max="2027-10-31" value={form.date} onChange={set('date')} className={inputClass} data-id="element-88" data-mp="1pa7ai8n7chun" />
        </div>
      </div>
      <div data-id="element-89" data-mp="1tc2lk4uxq9lm">
        <label htmlFor="ev-message" className={labelClass} data-id="element-90" data-mp="1tdvj8unkljhh">{e.message}</label>
        <textarea id="ev-message" rows={3} value={form.message} onChange={set('message')} className={inputClass} data-id="element-91" data-mp="1y9audeu711a7" />
      </div>
      {error && <p role="alert" className="text-sm font-medium text-rust" data-id="element-92" data-mp="39q14va5ngf9m">{e.required}</p>}
      <button type="submit" className="rounded-full bg-saddle px-6 py-3 font-bold text-cream transition-colors duration-150 hover:bg-leather focus:outline-none focus-visible:ring-2 focus-visible:ring-hay" data-id="element-93" data-mp="39s543eslsq3k">
        {e.send}
      </button>
    </form>;
}